export const storageGet = (key) => {
  const value = localStorage.getItem(key)
  return value;
}

export const storageSet = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
}
